(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["original-lp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // --- carousel ---
  const carousel = document.querySelector('.js-carousel');
  if (carousel) {
    const track = carousel.querySelector('.carousel__track');
    const prevBtn = carousel.querySelector('.carousel__nav--prev');
    const nextBtn = carousel.querySelector('.carousel__nav--next');
    const cards = track ? Array.from(track.querySelectorAll('.card')) : [];

    if (track && cards.length) {
      const getStep = () => {
        const rect = cards[0].getBoundingClientRect();
        return rect.width + 16;
      };

      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }
  }

  // --- scroll fixed button (FV超えたら表示 / shop到達で非表示) ---
  const fv = document.querySelector('.fv-video-hero');
  const shop = document.querySelector('#shop');
  const btn = document.querySelector('#scroll-btn');

  if (fv && shop && btn) {
    const updateBtn = () => {
      const fvRect = fv.getBoundingClientRect();
      const shopRect = shop.getBoundingClientRect();
      const vh = window.innerHeight;

      // FVを超えたら表示（下部固定）※表示タイミングテスト中
      if (fvRect.bottom < -1700) {
        btn.classList.add('is-visible', 'is-fixed');
      } else {
        btn.classList.remove('is-visible', 'is-fixed');
      }

      // shop が画面内に入ったら非表示（固定は維持でもOKだが、見せない）
      if (shopRect.top < vh) {
        btn.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', updateBtn, { passive: true });
    window.addEventListener('resize', updateBtn);
    updateBtn(); // 初期判定
  }

  // --- scroll reveal ---
  const sections = document.querySelectorAll('[data-reveal-section]');
  if (sections.length) {
    sections.forEach((root) => {
      const items = root.querySelectorAll('[data-scroll-reveal]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(el => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });

      items.forEach(el => observer.observe(el));
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-lp2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // --- carousel ---
  const carousel = document.querySelector('.js-carousel');
  if (carousel) {
    const track = carousel.querySelector('.carousel__track');
    const prevBtn = carousel.querySelector('.carousel__nav--prev');
    const nextBtn = carousel.querySelector('.carousel__nav--next');
    const cards = track ? Array.from(track.querySelectorAll('.card')) : [];

    if (track && cards.length) {
      const getStep = () => {
        const rect = cards[0].getBoundingClientRect();
        return rect.width + 16;
      };

      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }
  }

  // --- scroll fixed button (FV超えたら表示 / shop到達で非表示) ---
  const fv = document.querySelector('.fv-video-hero');
  const shop = document.querySelector('#shop');
  const btn = document.querySelector('#scroll-btn');

  if (fv && shop && btn) {
    const updateBtn = () => {
      const fvRect = fv.getBoundingClientRect();
      const shopRect = shop.getBoundingClientRect();
      const vh = window.innerHeight;

      // FVを超えたら表示（下部固定）※表示タイミングテスト中
      if (fvRect.bottom < -4000) {
        btn.classList.add('is-visible', 'is-fixed');
      } else {
        btn.classList.remove('is-visible', 'is-fixed');
      }

      // shop が画面内に入ったら非表示（固定は維持でもOKだが、見せない）
      if (shopRect.top < vh) {
        btn.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', updateBtn, { passive: true });
    window.addEventListener('resize', updateBtn);
    updateBtn(); // 初期判定
  }

  // --- scroll reveal ---
  const sections = document.querySelectorAll('[data-reveal-section]');
  if (sections.length) {
    sections.forEach((root) => {
      const items = root.querySelectorAll('[data-scroll-reveal]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(el => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });

      items.forEach(el => observer.observe(el));
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
